import {
  LOCATION_FETCH_FAIL,
  LOCATION_PERMISSION_STATUS_SET,
  LOCATION_RESET,
  LOCATION_SET,
  SET_ELECTRON,
  LOCATION_FETCHING,
  SET_WATCH_POSITION_LISTENER
} from '@actions/types'

const initialState = {
  currentLocation: null,
  electronLocale: null,
  electronOSUser: null,
  isElectron: null,
  permissionStatus: null,
  watchPositionId: null
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case LOCATION_PERMISSION_STATUS_SET:
    return {
      ...state,
      permissionStatus: payload
    }
  case LOCATION_RESET:
    return {
      ...state,
      currentLocation: null
    }
  case LOCATION_SET:
    return {
      ...state,
      ...payload
    }
  case LOCATION_FETCH_FAIL:
    return {
      ...state,
      currentLocation: null
    }
  case LOCATION_FETCHING:
    return {
      ...state,
      isAwaitingLocation: null
    }
  case SET_ELECTRON:
    return {
      ...state,
      ...payload
    }
  case SET_WATCH_POSITION_LISTENER:
    return {
      ...state,
      watchPositionId: payload
    }
  default:
    return state
  }
}

export default reducer
